/* Global Care — Koleksiyon: stoğu olmayan ürünleri TÜM sayfalar dahil en sona.
   Infinite scroll + kademeli gösterim. Stok durumu DOĞRUDAN kartın .xo-badge-sold-out
   rozetinden okunur (temanın gösterdiği "TÜKENDİ" ile birebir; products.json/handle/varyant
   eşleştirme riski YOK).
   - sunucu sayfa-1 kartlarından tükenenleri tampona alır
   - kaydırdıkça ?section_id=main-collection&page=N (+ mevcut filtre query'si) sonraki sayfaları getirir
   - stoktakileri hemen gösterir, tükenenleri tamponlar, tüm sayfalar bitince en sonda kademeli açar
   - sunucu sayfalamasını gizler; filtre/sıralama AJAX'ında sıfırlanıp yeniden çalışır
   Güvenlik: hata olursa mevcut görünüme dokunmaz. */
(function () {
  'use strict';
  if (window.__gcStockSort) return;
  window.__gcStockSort = 1;

  var SECTION_ID = 'main-collection';
  var MAXP = 80;
  var state = null, observer = null, pumping = false;

  function handle() { var m = location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? m[1] : null; }
  function grid() { return document.querySelector('.filters-content__grid'); }
  function isSold(card) { return !!(card && card.querySelector && card.querySelector('.xo-badge-sold-out')); }
  function cardKey(card) {
    var a = card && card.querySelector && card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function pageUrl(p) {
    var params = new URLSearchParams(location.search);
    params.set('section_id', SECTION_ID);
    params.set('page', p);
    return location.pathname + '?' + params.toString();
  }
  async function fetchPageCards(p) {
    var res;
    try { res = await fetch(pageUrl(p), { headers: { Accept: 'text/html' } }); } catch (e) { return null; }
    if (!res.ok) return null;
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var g = doc.querySelector('.filters-content__grid');
    if (!g) return null;
    return Array.prototype.slice.call(g.children);
  }
  function sentinelEl(g) {
    var s = document.querySelector('.gc-ss-sentinel');
    if (!s) { s = document.createElement('div'); s.className = 'gc-ss-sentinel'; s.style.cssText = 'width:100%;height:1px;'; g.parentNode.insertBefore(s, g.nextSibling); }
    return s;
  }
  function nearBottom(s) { if (!s) return false; var r = s.getBoundingClientRect(); return r.top <= (window.innerHeight || 800) + 600; }

  async function step(st) {
    if (st.busy) return;
    st.busy = true;
    try {
      if (!st.pagesDone) {
        var cards = await fetchPageCards(st.page);
        if (!cards || cards.length === 0) {
          st.pagesDone = true;
        } else {
          var frag = document.createDocumentFragment(), added = 0;
          for (var i = 0; i < cards.length; i++) {
            var c = cards[i], k = cardKey(c);
            if (k && st.seen[k]) continue;
            if (k) st.seen[k] = 1;
            if (isSold(c)) st.soldBuf.push(c); else { frag.appendChild(c); added++; }
          }
          if (added) st.grid.appendChild(frag);
          // sayfalamayı ancak ek sayfa BAŞARIYLA yüklendikten sonra gizle (güvenlik: fetch çökerse strand olma)
          if (added && !st.tookOver) {
            st.tookOver = true;
            document.querySelectorAll('xo-filters-paginate').forEach(function (el) { el.style.display = 'none'; });
          }
          st.page++;
          if (st.page > MAXP) st.pagesDone = true;
        }
      } else if (st.soldBuf.length) {
        var chunk = st.soldBuf.splice(0, 24), f2 = document.createDocumentFragment();
        for (var j = 0; j < chunk.length; j++) f2.appendChild(chunk[j]);
        st.grid.appendChild(f2);
      } else {
        st.done = true;
      }
      window.dispatchEvent(new Event('scroll'));
    } catch (e) { st.done = true; }
    finally { st.busy = false; }
  }

  async function pump() {
    var st = state;
    if (!st || pumping) return;
    pumping = true;
    try {
      while (st && !st.done && !st.busy && nearBottom(st.sentinel)) {
        await step(st);
        if (st.done && st.sentinel) { st.sentinel.remove(); st.sentinel = null; }
      }
    } finally { pumping = false; }
  }

  function start() {
    var h = handle(), g = grid();
    if (!h || !g) return;
    var st = { grid: g, page: 2, seen: Object.create(null), soldBuf: [], pagesDone: false, done: false, busy: false, sentinel: null };
    // sunucu sayfa-1 kartları: tükenenleri tampona al (DOM rozetiyle)
    var existing = Array.prototype.slice.call(g.children);
    for (var i = 0; i < existing.length; i++) {
      var c = existing[i], k = cardKey(c);
      if (k) st.seen[k] = 1;
      if (isSold(c)) { st.soldBuf.push(c); g.removeChild(c); }
    }
    st.sentinel = sentinelEl(g);
    state = st;
    pump();
  }

  function reset() {
    state = null;
    var s = document.querySelector('.gc-ss-sentinel'); if (s) s.remove();
  }

  function init() {
    if (!handle() || !grid()) return;
    start();
    window.addEventListener('scroll', pump, { passive: true });
    window.addEventListener('resize', pump);
    window.addEventListener('popstate', function () { reset(); setTimeout(start, 300); });
    try {
      var host = document.querySelector('xo-filters-content') || grid().parentNode;
      observer = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].removedNodes && muts[i].removedNodes.length) {
            if (!state || !document.contains(state.grid)) { reset(); setTimeout(start, 200); return; }
          }
        }
      });
      if (host) observer.observe(host, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
